/**
 * Who stands where in a company. The seats that anyone may take, before a seller or in a ring of
 * talk, are given out in the order people come: each takes the first that is free, and one who
 * finds none stands by. So no two stand in one spot, and it is still the same city at any hour:
 * who has which seat follows from the day's times alone.
 */
export const SEATING = {
  /** A seat is free for the next this long after it is left: time for the one to step away. */
  changeS: 3,
} as const;

export interface Sitting {
  /** Seconds into the day at which it comes to stand and at which it walks on. */
  readonly arrive: number;
  readonly leave: number;
}

/** Each sitting's seat among `seats` of them, or -1 for one that finds them all taken. */
export function seatInTurn(sittings: readonly Sitting[], seats: number): number[] {
  const order = sittings
    .map((_, i) => i)
    .sort((a, b) => sittings[a]!.arrive - sittings[b]!.arrive || a - b);
  const freeFrom = new Array<number>(seats).fill(-Infinity);
  const given = new Array<number>(sittings.length).fill(-1);
  for (const i of order) {
    const { arrive, leave } = sittings[i]!;
    if (!(leave > arrive)) continue;
    const seat = freeFrom.findIndex((from) => from <= arrive);
    if (seat < 0) continue;
    freeFrom[seat] = leave + SEATING.changeS;
    given[i] = seat;
  }
  return given;
}
